module.exports = __webpack_public_path__ + "static/media/junte e troque - curta a vida no seu ritmo.94adafde.png";